/**
 * Pre-Cart Theme Extension
 * Intercepteert "Add to cart" form submits en redirect naar pre-cart pagina
 */

(function() {
  'use strict';

  // Wacht tot DOM geladen is
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Functie om forms te vinden en te intercepten
    function setupInterceptors() {
      // Vind alle product forms
      const productForms = document.querySelectorAll('form[action*="/cart/add"], form[action="/cart/add"], form[data-type="add-to-cart-form"]');
      
      productForms.forEach(form => {
        // Check of dit een product form is (heeft variant selectors of id input)
        const hasVariantInput = form.querySelector('input[name="id"], input[name="variant_id"], select[name="id"]');
        if (hasVariantInput) {
          interceptForm(form);
        }
      });
    }
    
    // Setup direct als DOM al geladen is
    setupInterceptors();
  }

  function interceptForm(form) {
    // Check if we already intercepted this form (prevent duplicates without heavy DOM manipulation)
    if (form.dataset.precartIntercepted === 'true') {
      return;
    }
    form.dataset.precartIntercepted = 'true';
    
    // Use capture phase (true) to intercept BEFORE product-form.js
    form.addEventListener('submit', async function(e) {
      // Check EERST: zijn we op een product pagina? Pre-cart werkt niet op product pages
      if (window.location.pathname.includes('/products/')) {
        // Product pagina: pre-cart uitschakelen, laat normale flow doorgaan
        return;
      }
      
      // Skip product card forms - deze worden afgehandeld door kc-card-product.liquid
      if (form.classList.contains('kc-act') && form.dataset.kcCart === 'drawer') {
        return;
      }

      // CRITICAL: Check if this submit is already being processed (prevent double submission)
      if (form.dataset.precartProcessing === 'true') {
        console.log('[Pre-Cart] Form submit already being processed, ignoring duplicate');
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }
      
      // Check if product has accessoires via data attribute
      // Check both form element and parent product-form element
      const productFormElement = form.closest('product-form');
      const hasAccessoires = (form.dataset && form.dataset.hasAccessoires === 'true') || 
                           (productFormElement && productFormElement.dataset && productFormElement.dataset.hasAccessoires === 'true');
      
      // Check if user has selected any accessoires via checkboxes
      const hasSelectedAccessoires = window.selectedProductAccessoires && 
                                    typeof window.selectedProductAccessoires.getSelected === 'function' &&
                                    window.selectedProductAccessoires.getSelected().length > 0;
      
      const productHandle = (form.dataset && form.dataset.productHandle) || 
                           (productFormElement && productFormElement.dataset && productFormElement.dataset.productHandle) ||
                           (window.product && window.product.handle) ||
                           (window.location.pathname.match(/\/products\/([^\/\?]+)/)?.[1]);
      
      console.log('[Pre-Cart] Form submit intercepted. hasAccessoires:', hasAccessoires, 'hasSelectedAccessoires:', hasSelectedAccessoires, 'productHandle:', productHandle);
      
      // If product doesn't have accessoires, let normal flow continue
      if (!hasAccessoires) {
        // Product has no accessoires - don't intercept, let normal cart flow proceed
        return;
      }

      // If user has selected accessoires, let normal flow continue (product-form.js will handle it)
      // We only redirect to pre-cart if product HAS accessoires but user hasn't selected any
      if (hasSelectedAccessoires) {
        console.log('[Pre-Cart] User has selected accessoires, letting normal cart flow proceed');
        return; // Don't intercept, let product-form.js handle it
      }

      // Product has accessoires - intercept and redirect to pre-cart
      // CRITICAL: Prevent default en stop ALL propagation VOORDAT product-form.js het kan doen
      // Zet deze flags EERST om race conditions te voorkomen
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.cancelBubble = true;
      
      // Mark form as processing (prevent double submission)
      form.dataset.precartProcessing = 'true';
      
      // Mark dat we naar pre-cart gaan (ZET DIT DIRECT om product-form.js te blokkeren)
      window._precartRedirecting = true;

      try {
        // Haal form data op
        const formData = new FormData(form);
        const variantId = formData.get('id') || formData.get('variant_id');
        
        if (!variantId) {
          // Geen variant ID gevonden, laat normale submit doorgaan
          console.warn('Pre-Cart: Geen variant ID gevonden, normale submit uitgevoerd');
          window._precartRedirecting = false;
          form.dataset.precartProcessing = 'false';
          form.submit();
          return;
        }

        // Sla data op in localStorage
        try {
          localStorage.setItem('precart_last_variant_id', variantId.toString());
          if (productHandle) {
            localStorage.setItem('precart_last_handle', productHandle);
          }
          localStorage.setItem('precart_last_url', window.location.href);
        } catch (storageError) {
          console.warn('Pre-Cart: localStorage niet beschikbaar:', storageError);
          // Fallback: gebruik sessionStorage
          try {
            sessionStorage.setItem('precart_last_variant_id', variantId.toString());
            if (productHandle) {
              sessionStorage.setItem('precart_last_handle', productHandle);
            }
            sessionStorage.setItem('precart_last_url', window.location.href);
          } catch (sessionError) {
            console.error('Pre-Cart: sessionStorage ook niet beschikbaar:', sessionError);
          }
        }

        // Check inventory before adding (ALLEEN als inventory tracking aan staat)
        // Dit gebeurt ALLEEN bij form submit (click op add to cart), NIET preventief
        const variantInput = form.querySelector(`input[name="id"][value="${variantId}"]`);
        if (variantInput && variantInput.dataset.inventoryManagement === 'true') {
          const inventoryQuantity = variantInput.dataset.inventoryQuantity;
          // Alleen checken als inventory quantity beschikbaar is (niet 'null' of leeg)
          if (inventoryQuantity && inventoryQuantity !== 'null' && inventoryQuantity !== null) {
            const maxQuantity = parseInt(inventoryQuantity, 10);
            // Alleen checken als maxQuantity een geldig getal is en groter dan 0
            if (!isNaN(maxQuantity) && maxQuantity > 0) {
              // Fetch cart ONLY bij form submit (niet preventief)
              try {
                const cartResponse = await fetch('/cart.js');
                const cart = await cartResponse.json();
                const currentItem = cart.items.find(item => item.variant_id.toString() === variantId.toString());
                const currentQuantity = currentItem ? currentItem.quantity : 0;
                const requestedQuantity = parseInt(formData.get('quantity') || '1', 10);
                const newTotal = currentQuantity + requestedQuantity;
                
                // Alleen blokkeren als inventory_policy 'deny' is (geen backorder)
                if (newTotal > maxQuantity && variantInput.dataset.inventoryPolicy === 'deny') {
                  // Show error message
                  if (typeof showCartItemError === 'function') {
                    showCartItemError(variantId, maxQuantity);
                  } else {
                    alert(`Het is niet mogelijk om meer dan ${maxQuantity} toe te voegen.`);
                  }
                  window._precartRedirecting = false;
                  form.dataset.precartProcessing = 'false';
                  return;
                }
              } catch (error) {
                console.error('Error checking inventory:', error);
                // Continue on error - don't block user if inventory check fails
                window._precartRedirecting = false;
                form.dataset.precartProcessing = 'false';
                return;
              }
            }
          }
        }

        // Voeg product toe aan cart via AJAX
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          window._precartRedirecting = false;
          form.dataset.precartProcessing = 'false';
          throw new Error(errorData.description || errorData.message || 'Error bij toevoegen aan winkelwagen');
        }

        // Redirect naar pre-cart pagina (direct, geen setTimeout)
        // GEEN vinkje tonen - we gaan redirecten
        const queryParams = new URLSearchParams();
        queryParams.set('variant_id', variantId.toString());
        if (productHandle) {
          queryParams.set('handle', productHandle);
        }
        queryParams.set('url', window.location.href);

        // Direct redirect, geen delay
        window.location.href = '/pages/pre-cart?' + queryParams.toString();

      } catch (error) {
        console.error('Pre-Cart: Error bij intercept:', error);
        // Reset flags bij error
        window._precartRedirecting = false;
        form.dataset.precartProcessing = 'false';
        // Don't submit form again - we already prevented default
        // User can retry manually
        alert('Er is een fout opgetreden bij het toevoegen van het product. Probeer het opnieuw.');
      }
    }, { capture: true }); // Gebruik capture phase om andere handlers te overschrijven
  }

  // Luister ook naar dynamisch toegevoegde forms (bijv. via AJAX)
  // Gebruik een throttled MutationObserver om performance te verbeteren
  let observerTimeout;
  const observer = new MutationObserver(function(mutations) {
    // Throttle observer callbacks om performance te verbeteren (max 1x per 100ms)
    clearTimeout(observerTimeout);
    observerTimeout = setTimeout(function() {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check of het node zelf een form is
            if (node.tagName === 'FORM' && (node.action && node.action.includes('/cart/add'))) {
              const hasVariantInput = node.querySelector('input[name="id"], input[name="variant_id"], select[name="id"]');
              if (hasVariantInput && node.dataset.precartIntercepted !== 'true') {
                interceptForm(node);
              }
            }
            // Check of er forms in de node zitten
            const forms = node.querySelectorAll && node.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
            if (forms && forms.length > 0) {
              forms.forEach(form => {
                const hasVariantInput = form.querySelector('input[name="id"], input[name="variant_id"], select[name="id"]');
                if (hasVariantInput && form.dataset.precartIntercepted !== 'true') {
                  interceptForm(form);
                }
              });
            }
          }
        });
      });
    }, 100); // Throttle to max once per 100ms
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();



